import { useEffect, useState } from "react";
import { load, Obj } from "scrivito";
import type * as Scrivito from "scrivito";
import type { ProductImage } from "interfaces/product/product.types";

export const useFetchScrivitoImages = (images: ProductImage[]) => {
  const [scrivitoImages, setScrivitoImages] = useState<Scrivito.Obj[]>([]);

  useEffect(() => {
    const productImagePimIds = images
      .map((img) => img.pimId)
      .filter((item) => item !== "");

    const fetchData = async () => {
      if (productImagePimIds.length > 0) {
        await load(() =>
          Obj.where("pimId", "equals", productImagePimIds).take(),
        ).then((objs) => {
          const idList = images.map((img) => img.pimId);

          const sortedFilledObjs = idList
            .map((pimId) => {
              const selectedObj = objs.find(
                (obj) => obj.get("pimId") === pimId,
              );
              return selectedObj;
            })
            .filter((obj): obj is Scrivito.Obj => obj !== undefined);

          setScrivitoImages(sortedFilledObjs);
        });
      }
    };

    fetchData();
  }, [images]);

  return scrivitoImages;
};
